module.exports = __webpack_public_path__ + "static/media/1009865.1f317228.jpg";